import styled from "styled-components";

export const SubNameTxt = styled.span`
  width: 100%;
  margin-top: 0;
  padding-top: 0;
  font-size: 1.1rem;
  font-weight: lighter;
  @media (min-width: 900px) {
    width: 80%;
  }
`;
